import { groupAccountMapEntityName } from '../shared/entities/groupAccountMapTypes';
export function getGroupAccountMapStorage(context) {
    return context.storage(groupAccountMapEntityName);
}
